import React from 'react';
import { LegendDisplayMode } from './types';
import { VizLegendTable } from './VizLegendTable';
import { VizLegendList } from './VizLegendList';
/**
 * @public
 */
export var VizLegend = function (_a) {
    var items = _a.items, displayMode = _a.displayMode, sortKey = _a.sortBy, sortDesc = _a.sortDesc, onToggleSort = _a.onToggleSort, onLabelClick = _a.onLabelClick, onSeriesColorChange = _a.onSeriesColorChange, placement = _a.placement, className = _a.className;
    switch (displayMode) {
        case LegendDisplayMode.Table:
            return (React.createElement(VizLegendTable, { className: className, items: items, placement: placement, sortBy: sortKey, sortDesc: sortDesc, onLabelClick: onLabelClick, onToggleSort: onToggleSort, onSeriesColorChange: onSeriesColorChange }));
        case LegendDisplayMode.List:
            return (React.createElement(VizLegendList, { className: className, items: items, placement: placement, onLabelClick: onLabelClick, onSeriesColorChange: onSeriesColorChange }));
        default:
            return null;
    }
};
VizLegend.displayName = 'Legend';
//# sourceMappingURL=VizLegend.js.map